import { CarrierAccount } from "@redotech/redo-model/carrier-account/carrier-account";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const getCarrierAccounts = {
  name: "getCarrierAccounts" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: z.object({
    merchantCarrierAccounts: z.array(CarrierAccount),
    customerCarrierAccounts: z.array(CarrierAccount),
    redoChildCarrierAccounts: z.array(CarrierAccount),
  }),
};
